angular.module('content.widgets.DCSWidgetService', [
])

/**
 * The DCSWidgetService service handles scoring and
 * feedback for the state.contentView type
 *
 * @class DCSWidgetService
 * @constructor
 * @module content.widgets.DCSWidgetService
 */
.factory('DCSWidgetService', [
  function () {
    'use strict';

    var service = {

      breadcrumbs: [],

      /**
       * Finds the breadcrumb for a given widget
       *
       * @param {string} id - ID of the widget
       * @param {Object} model - formatted data model to pull breadcrumbs from
       * @return {Array<Object>} List of breadcrumbs
       */
      get: function go(id, model) {
        var item;

        _.forEach(model.collection, function (obj) {
          if (!service.breadcrumbs[obj.id]) {
            service.breadcrumbs[obj.id] = _.map(
              service.breadcrumbs[model.id],
              function (crumb) {
                return { label: crumb.label, id: crumb.id };
              }
            );
            service.breadcrumbs[obj.id].push({ label: obj.label, id: obj.id });
          }
          if (obj.id === id) {
            item = obj;
          }
          if (obj.collection && !item) {
            item = service.get(id, obj);
          }
        });

        return item;
      },

      /**
       * Finds the breadcrumb for a given widget
       *
       * @param {string} id - ID of the widget
       * @return {Array<Object>} List of breadcrumbs
       */
      getBreadcrumbs: function getBreadcrumbs(id) {
        return service.breadcrumbs[id];
      },

      /**
       * Cleans the data provided, adding IDs and formatting.
       *
       * @param {Object} data - Widget data
       * @return {Object} Merged data
       */
      cleanData: function cleanData(data) {
        data.content.collection = service.parseCollection(data.content.collection);
        data.content.media = service.parseCollection(data.content.media);

        return data;
      },

      /**
       * Sub proccess that parses a media object.
       * Empty medias are removed otherwise are
       * they are given an id
       *
       * @param {Object} media - Widget media object
       * @return {Object} Processed widget media object
       */
      parseMedia: function parseMedia(media) {
        _.forEach(media, function (obj) {
          obj.id = obj.id || 'media-' + uuid.v1();
        });

        return media;
      },

      /**
       * Sub proccess that parses a collection object.
       * Empty collections are removed otherwise are
       * they are given an id
       *
       * @param {Object} collection - Widget collection object
       * @return {Object} Processed widget collection object
       */
      parseCollection: function parseCollection(collection) {
        console.log('collection', collection);

        _.forEach(collection, function (obj) {
          obj.id = obj.id || 'widget-' + uuid.v1();
          if (obj.media) {
            obj.media = service.parseMedia(obj.media);
          }
          if (_.size(obj.collection) < 1) {
            delete obj.collection;
          } else {
            obj.collection = service.parseCollection(obj.collection);
          }
        });

        return collection;
      },

      /**
       * Returns the model from the form/editor service
       *
       * @param {Object} formattedModel - model to be formatted
       * @return {Object} Widget model
       */
      getModel: function getModel(formattedModel) {
        var model = {
          label: formattedModel.title,
          content: {
            type: formattedModel.type,
            media: formattedModel.media,
            collection: formattedModel.collection
          }
        };

        model = service.cleanData(model);

        return model;
      },

      nestCollection: function nestCollection(settings) {
        var level = 1;
        var collection = {};
        var items = {};

        _.times(settings.depth, function (i) {
          var t;
          var m;
          var ta;
          var c;
          var mTemplate;
          var tTemplate;
          var taTemplate;
          var cTemplate = {
            startEmpty: true,
            key: 'collection',
            title: settings.title + ' ' + level,
            type: settings.type,
            collapseTitle: settings.collapseTitle,
            offset: 1,
            items: [],
            htmlClass: 'level' + level,
            notitle: false,
            style: {
              add: 'btn-link'
            }
          };

          var keyPath = 'collection[]';

          _.times(level - 1, function () {
            keyPath += '.collection[]';
          });

          // TODO: Figure out if this cTemplate can be removed
          cTemplate = {
            startEmpty: true,
            key: 'collection',
            title: settings.title + ' ' + level,
            type: settings.type,
            collapseTitle: settings.collapseTitle,
            offset: 1,
            items: [],
            htmlClass: 'level' + level,
            notitle: false,
            style: {
              add: 'btn-link'
            }
          };

          mTemplate = {
            key: keyPath + '.media',
            title: 'Media',
            collapseTitle: 'Media Items',
            startEmpty: true,
            offset: 0,
            type: 'horizontal-array',
            style: {
              add: 'btn-link'
            },
            items: [
              {
                key: keyPath + '.media[].uri',
                title: 'Link',
                type: 'text'
              },
              {
                key: keyPath + '.media[].type',
                title: 'Type',
                type: 'select'
              },
              {
                key: keyPath + '.media[].description',
                title: 'Caption/Transcript',
                type: 'textarea'
              },
              {
                key: keyPath + '.media[].screenReaderOnly',
                type: 'boolean',
                title: 'Screen Reader Only',
                default: false
              }
            ]
          };

          tTemplate = {
            key: keyPath + '.label',
            title: 'Label',
            type: 'text'
          };

          taTemplate = {
            key: keyPath + '.value',
            title: 'Text',
            type: 'textarea'
          };

          if (i === 0) {
            collection = _.clone(cTemplate);
            items = collection;
          }


          t = _.clone(tTemplate);
          m = _.clone(mTemplate);
          ta = _.clone(taTemplate);
          c = _.clone(cTemplate);
          c.offset = 0;
          c.key = keyPath + '.collection';
          c.title = 'Level ' + (level + 1);
          c.htmlClass = 'level' + (level + 1);

          if (i === settings.depth - 1) {
            c = '';
          }

          items.items = [
            t, ta, m, c
          ];

          items = c;
          level += 1;
        });

        return collection;
      },


      configureForm: function (formattedModel) {
        var form = { schema: {}, form: {}, model: {} };
        form.model = formattedModel;

        /**
         * sortableOptions used to configure UI Sortable options
         *
         */
        form.sortableOptions = {
          axis: 'y',
          handle: '> > > .draghandle',
          containment: 'parent',
          tolerance: 'pointer',
          delay: 100,
          'ui-floating': 'auto',
          appendTo: 'parent',
          forceHelperSize: true,
          helper: 'clone',
          scroll: true,
          start: function () {
            angular.element(this).sortable('refreshPositions');
            angular.element('.add-item').css({ visibility: 'hidden' });
            angular.element('body').css({ overflow: 'hidden' });
          },
          stop: function () {
            angular.element('.add-item').css({ visibility: 'visible' });
            angular.element('body').css({ overflow: 'auto' });
          }
        };

        /**
         * tinymceOptions sets up TinyMCE
         */
        form.tinymceOptions = {
          branding: false,
          menubar: false,
          forced_root_block: '',
          plugins: 'advlist autolink lists link image charmap print preview hr anchor pagebreak table paste',
          toolbar: 'undo redo removeformat spellchecker | formatselect table | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table | link unlink | subscript superscript',
          default_link_target: '_blank'
        };

        /**
         * addEntryItem add an entry item
         *
         * @param {Object} entry - entry array
         * @param {index} index - array index
         */
        form.addEntryItem = function (entry, index) {
          var obj = {
            id: uuid.v1(),
            label: '',
            value: '',
            media: [],
            collection: []
          };

          if (!entry.collection) {
            entry.collection = [];
          }

          if (!_.isUndefined(index)) {
            entry.collection.splice(index + 1, 0, obj);
          } else {
            entry.collection.unshift(obj);
          }
        };

        /**
         * removeEntryItem remove an entry item
         *
         * @param {Array} array - entry array
         * @param {index} index - media index
         */
        form.removeEntryItem = function (array, index) {
          array.splice(index, 1);
        };
        /**
         * addMediaItem add a media item
         *
         * @param {Array} mediaArray - media array
         * @param {index} index - array index
         */
        form.addMediaItem = function (mediaArray, index) {
          var obj = {
            id: uuid.v1(),
            type: '',
            url: '',
            description: ''
          };

          if (!_.isUndefined(index)) {
            mediaArray.splice(index + 1, 0, obj);
          } else {
            mediaArray.unshift(obj);
          }
        };

        /**
         * removeMediaItem remove a media item
         *
         * @param {Array} array - media array
         * @param {index} index - media index
         */
        form.removeMediaItem = function (array, index) {
          array.splice(index, 1);
        };

        return form;
      }
    };

    return service;
  }
]);
